import PropTypes from 'prop-types';
import { TbDroplet, TbDatabase } from 'react-icons/tb';
const WaterLevel = ({ dataSource, title = 'Volume' }) => {
    const parsed = dataSource == null || String(dataSource).trim() === '' ? NaN : parseFloat(dataSource);
    const value = Number.isFinite(parsed) ? Math.round(parsed).toLocaleString('en-US') : '\u2014';
    const Icon = title.includes('Stock') ? TbDatabase : TbDroplet;
    return <div className={`analytics-metric ${title === 'Consumption' ? 'analytics-consumption' : ''}`}>
        <span className="analytics-metric-icon"><Icon /></span>
        <div><h3>{title}</h3><p className="analytics-value">{value} <span>Liter</span></p></div>
    </div>;
};
WaterLevel.propTypes = { dataSource: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), title: PropTypes.string };
export default WaterLevel;
